import { PushNotificationTokenType } from 'APP/model/pushNotifications/pushNotificationsModel.types';
import { Notification_TokenType } from 'APP/wsApi/wsAppApi/types/notifications/notification_request_pb';

export const pushNotificationTokenTypeRequestMap: Record<
  PushNotificationTokenType,
  Notification_TokenType
> = {
  [PushNotificationTokenType.default]: Notification_TokenType.MESSAGE,
  [PushNotificationTokenType.voip]: Notification_TokenType.VOIP,
};
